import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useStepProcessor } from '../../context/StepProcessorContext';
import { sendOTP } from '../../services/AuthService';
import { toast } from 'react-toastify';
import { useOrganization } from '../../context/OrganizationContext';

const EmailStep: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { goToNextStep, completeStep } = useStepProcessor();
  const { organizationData } = useOrganization();

  const validateEmail = (email: string): boolean => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateEmail(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    if (!organizationData) {
      toast.error('Organization data not found');
      return;
    }

    setIsLoading(true);
    try {
      const response = await sendOTP(email, organizationData.id);
      
      if (response.status.success) {
        // Store email in session storage for the next step
        localStorage.setItem('auth_email', email);
        completeStep('email');
        goToNextStep();
        toast.success('OTP sent successfully');
      } else {
        toast.error(response.status.errorMessage || 'Failed to send OTP');
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      toast.error('An error occurred while sending OTP');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="flex flex-col items-center justify-center p-4"
    >
      <div className="w-full max-w-md">
        <h2 className="text-xl font-semibold mb-6 text-center">Enter Your Email</h2>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-customBlue"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full py-2 px-4 rounded-md text-white font-medium ${
              isLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-customBlue hover:bg-blue-700'
            }`}
          >
            {isLoading ? 'Sending OTP...' : 'Send OTP'}
          </button>
        </form>
      </div>
    </motion.div>
  );
};

export default EmailStep;
